//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name:'FraminghamCHDRisk',
  data() {
    return {
      form:{
        diabetes:'0',
        heartDisease:'0',
        gender: '1',
        age: '',
        hdl: '',
        cholesterol: '',
        treatmentState: '0',
        systolicBloodPressure: '',
        smoking:'0',
      },
      disabled:false,
      hasScore: false,
      dataList1:[
        {value:"1",name:'男'},
        {value:"0",name:'女'},
      ],
      dataList2:[
        {value:"0",name:'20-34岁'},
        {value:"2",name:'35-39岁'},
        {value:"5",name:'40-44岁'},
        {value:"7",name:'45-49岁'},
        {value:"8",name:'50-54岁'},
        {value:"10",name:'55-59岁'},
        {value:"11",name:'60-64岁'},
        {value:"12",name:'65-69岁'},
        {value:"14",name:'70-74岁'},
        {value:"15",name:'75+岁'},
      ],
      dataList3:[
        {value:"-2",name:'>1.6（mmol/L）'},
        {value:"-1",name:'1.3-1.6（mmol/L）'},
        {value:"0",name:'1.2-1.29（mmol/L）'},
        {value:"1",name:'0.9-1.19（mmol/L）'},
        {value:"2",name:'<0.9（mmol/L）'},
      ],
      dataList4:[
        {value:"0",name:'>4.1（mmol/L）'},
        {value:"1",name:'4.1-5.19（mmol/L）'},
        {value:"2",name:'5.2-6.19（mmol/L）'},
        {value:"3",name:'6.2-7.2（mmol/L）'},
        {value:"4",name:'<7.2（mmol/L）'},
      ],
      dataList5:[
        {value:"0",name:'未治疗'},
        {value:"1",name:'治疗后'},
      ],
      dataList6:[ // 收缩压 女（治疗后）
        {value:"-1",name:'<120（mmHg）'},
        {value:"2",name:'120-129（mmHg）'},
        {value:"3",name:'130-139（mmHg）'},
        {value:"5",name:'140-149（mmHg）'},
        {value:"6",name:'150-159（mmHg）'},
        {value:"7",name:'160+（mmHg）'},
      ],
      logit: "...",
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    show(){
      return this.form.diabetes == 0 && this.form.heartDisease == 0
    },
    /** 计算公式结果 */
    score() {
      let self = this;
      let form = JSON.parse(JSON.stringify(self.form));
      let flag = true;
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false;
          } else {
            form[key] = Number(form[key]);
          }
        }
      }
      if (!flag) {
        self.hasScore = false;
        self.logit = "...";
        return "";
      } else {
        if (form.gender =='1') { //男
          // 收缩压 男（未治疗）
          if (form.treatmentState == 0) {
            form.systolicBloodPressure = (form.systolicBloodPressure == -1
              ? -2
              : form.systolicBloodPressure == 2
                ? 0
                : form.systolicBloodPressure == 3
                  ? 1
                  : form.systolicBloodPressure == 5
                    ? 2
                    : form.systolicBloodPressure == 6
                      ? 2
                      : form.systolicBloodPressure == 7
                        ? 3
                        : '')
          } else { // 收缩压 男（治疗后）
            form.systolicBloodPressure = (form.systolicBloodPressure == -1
              ? 0
              : form.systolicBloodPressure == 2
                ? 2
                : form.systolicBloodPressure == 3
                  ? 3
                  : form.systolicBloodPressure == 5
                    ? 4
                    : form.systolicBloodPressure == 6
                      ? 4
                      : form.systolicBloodPressure == 7
                        ? 5
                        : '')
          }

          //吸烟
          form.smoking = form.smoking == 1 ? 4 :0;
        } else { //女
          // 年龄
          form.age = (form.age == 5
            ? 4
            : form.age == 7
              ? 5
              : form.age == 8
                ? 7
                : form.age == 10
                  ? 8
                  : form.age == 11
                    ? 9
                    : form.age == 12
                      ? 10
                      : form.age == 14
                        ? 11
                        : form.age == 15
                          ? 12
                          : '')
          // 收缩压 女（未治疗）
          if (form.treatmentState == 0) {
            form.systolicBloodPressure = (form.systolicBloodPressure == -1
              ? -3
              : form.systolicBloodPressure == 2
                ? 0
                : form.systolicBloodPressure == 3
                  ? 1
                  : form.systolicBloodPressure == 5
                    ? 2
                    : form.systolicBloodPressure == 6
                      ? 4
                      : form.systolicBloodPressure == 7
                        ? 5
                        : '')
          }

          //吸烟
          form.smoking = form.smoking == 1 ? 3 :0;
        }

        let result = form.age + form.hdl + form.cholesterol + form.systolicBloodPressure + form.smoking;

        if (form.gender =='1') { //男
          self.logit = (result <= -3
            ? '<1'
            : result == -2
              ? 1.1
              : result == -1
                ? 1.4
                : result == 0
                  ? 1.6
                  : result == 1
                    ? 1.9
                    : result == 2
                      ? 2.3
                      : result == 3
                        ? 2.8
                        : result == 4
                          ? 3.3
                          : result == 5
                            ? 3.9
                            : result == 6
                              ? 4.7
                              : result == 7
                                ? 5.6
                                : result == 8
                                  ? 6.7
                                  : result == 9
                                    ? 7.9
                                    : result == 10
                                      ? 9.4
                                      : result == 11
                                        ? 11.2
                                        : result == 12
                                          ? 13.3
                                          : result == 13
                                            ? 15.6
                                            : result == 14
                                              ? 18.4
                                              : result == 15
                                                ? 21.6
                                                : result == 16
                                                  ? 25.3
                                                  : result == 17
                                                    ? 29.4
                                                    : result == 18
                                                      ? '>30'
                                                      : result == 19
                                                        ? '>30'
                                                        : result == 20
                                                          ? '>30'
                                                          : result >= 21
                                                            ? '>30'
                                                            : '...')
        } else { //女
          self.logit = (result <= -3
            ? '<1'
            : result == -2
              ? '<1'
              : result == -1
                ? 1.0
                : result == 0
                  ? 1.2
                  : result == 1
                    ? 1.5
                    : result == 2
                      ? 1.7
                      : result == 3
                        ? 2.0
                        : result == 4
                          ? 2.4
                          : result == 5
                            ? 2.8
                            : result == 6
                              ? 3.3
                              : result == 7
                                ? 3.9
                                : result == 8
                                  ? 4.5
                                  : result == 9
                                    ? 5.3
                                    : result == 10
                                      ? 6.3
                                      : result == 11
                                        ? 7.3
                                        : result == 12
                                          ? 7.3
                                          : result == 13
                                            ? 10.0
                                            : result == 14
                                              ? 11.7
                                              : result == 15
                                                ? 13.7
                                                : result == 16
                                                  ? 15.9
                                                  : result == 17
                                                    ? 18.51
                                                    : result == 18
                                                      ? 21.5
                                                      : result == 19
                                                        ? 24.8
                                                        : result == 20
                                                          ? 27.5
                                                          : result >= 21
                                                            ? '>30'
                                                            : '...')
        }
        self.hasScore = true;
        return String(result);
      }
    },
    /** 计算公式结果 */
    descTxt() {
      if(!this.show) {
        return '该评分仅适用20-79岁无糖尿病或心脏病的成年人'
      }
    }
  },
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Card/FraminghamCHDRisk.vue